export default __webpack_public_path__ + "static/media/Cloudxier_graphics-each-expertise-02.22ceec3c.png";